import { Box } from "@mui/material";
import React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import { useNavigate } from "react-router-dom";
import EditIcon from "assets/EditIcon.svg";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#0A3575",
    color: theme.palette.common.white,
    height: "52px",
    fontSize: "16px",
    fontWeight: 600,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: "16px",
    height: "100px",
    color: "#191E31",
    fontWeight: 600,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "#ffffff",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const AccessTable = ({ columns, rows ,url}) => {
  const navigate = useNavigate();
  return (
    <Box>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              {columns?.map((column, index) => (
                <StyledTableCell key={index} align={column.align || "left"}>
                  {column.label}
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows?.map((row, rowIndex) => (
              <StyledTableRow key={rowIndex}>
                {columns?.map((column, colIndex) => (
                  <StyledTableCell
                    key={colIndex}
                    align={column.align || "left"}
                    width={column.width ||""}
                  >
                    {column.field === "action" ? (
                      <img
                        style={{ cursor: "pointer",opacity:row?.status == "In Active"?0.3:1}}
                        className={row[column.field]}
                        onClick={() =>
                          row?.status == "In Active"?"":navigate(`${url}`, { state: { rowData: row } })
                        }            
                        src={EditIcon}
                        alt="Edit"
                      />
                    ) : (
                      row[column.field]
                    )}
                  </StyledTableCell>
                ))}
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default AccessTable;
